/** No keyboard/mouse/touch activity before the session-timeout dialog is shown. */
export const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
